import axios from 'axios';
import {
  helperGetApiHeaders,
  helperGetApiRouteById,
  helperConvertApiRoute,
  apiErrorHandler,
} from 'helpers/ApiHelper';

export const FETCH_VIDEO = 'FETCH_VIDEO';
export const FETCH_VIDEO_PANEL = 'FETCH_VIDEO_PANEL';
export const CLEAR_VIDEO = 'CLEAR_VIDEO';

export function fetchVideoPanel(id, accessToken, deviceId) {
  const pageType = 'videoDetail';
  const request = axios
    .get(
      helperGetApiRouteById(pageType, id, '{videoId}'),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_VIDEO_PANEL,
    payload: request,
  };
}

export function fetchVideo(url, accessToken, deviceId) {
  const pageType = 'videoDetail';
  const request = axios
    .get(
      helperConvertApiRoute(url),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_VIDEO,
    payload: request,
  };
}

export function clearVideo() {
  return {
    type: CLEAR_VIDEO,
  };
}
